import {
  createShapeId,
  getIndexAbove,
  getIndexBetween,
  sortByIndex,
  TldrawUiMenuActionItem,
  TldrawUiMenuGroup,
  TldrawUiMenuItem,
  TldrawUiMenuSubmenu,
  TLPageId,
  useEditor,
  useReadonly,
  useToasts,
  useUiEvents,
  useValue,
} from "tldraw"
import { useCurrentPage } from "../hooks/useCurrentPage"
import { CustomDrawShape } from "../../shared/CustomDrawShape"
import { Expr } from "../../shared/Expr"
import { useMemo } from "react"
import { last } from "../util/array"
import { useAppDispatch } from "../app/hooks"
import { setEditingLayer } from "../features/app/appSlice"
import { LDPage } from "../../shared/LDPage"
import { LDShape } from "../../shared/LDShape"

type Props = {}
export function MoveToLayerMenu(props: Props) {
  const dispatch = useAppDispatch()
  const editor = useEditor()
  const pages = useValue("pages", () => editor.getPages(), [editor])
  const currentPageId = useValue(
    "current page id",
    () => editor.getCurrentPageId(),
    [editor],
  )
  const page = useCurrentPage()
  const { addToast } = useToasts()
  const trackEvent = useUiEvents()
  const isReadonlyMode = useReadonly()
  const oneSelected = editor.getSelectedShapeIds().length === 1
  const selectedShapes = editor.getSelectedShapes() as CustomDrawShape[]

  if (isReadonlyMode) return null

  const layers = page.meta.layers
  console.log({ layers })

  const sortedLayers = useMemo(
    () => [...Object.values(page.meta.layers)].sort(sortByIndex),
    [page.meta.layers],
  )
  if (
    selectedShapes.some((s) => s.props.isFill) &&
    selectedShapes.some((s) => !s.props.isFill)
  )
    return

  return (
    <TldrawUiMenuSubmenu id="move-to-layer" label="Move to Layer" size="small">
      <TldrawUiMenuGroup id="layers">
        {Object.keys(layers).map((layerId) => {
          const layer = layers[layerId]
          return (
            <TldrawUiMenuItem
              id={layerId}
              key={layerId}
              disabled={false}
              label={
                layer.name.length > 30
                  ? `${layer.name.slice(0, 30)}…`
                  : layer.name
              }
              onSelect={() => {
                editor.markHistoryStoppingPoint("move_shapes_to_layer")
                editor.updateShapes(
                  editor.getSelectedShapeIds().map((shapeId) => {
                    const shape = editor.getShape(shapeId) as CustomDrawShape
                    const pageMeta = page.meta

                    const layersArray = Object.values(pageMeta.layers).sort()

                    const newLayer =
                      layersArray.find((l) => l.id === layerId) ??
                      pageMeta.layers[pageMeta.currentLayer]

                    const newLayerIndexInList = layersArray.findIndex(
                      (l) => l.id === newLayer.id,
                    )
                    //console.log("currentLayerIndex", layersArray[currentLayerIndexInList].index)
                    const layerAbove =
                      layersArray[newLayerIndexInList + 1] ?? null
                    //console.log("layerAbove", layerAbove)

                    const highestShapeIndexOnCurrentLayer =
                      editor
                        .getCurrentPageShapes()
                        .filter(
                          (s) =>
                            LDShape.getLayerId(s as LDShape) === newLayer.id,
                        )
                        .sort((a, b) => b.index.localeCompare(a.index))[0]
                        ?.index ?? layersArray[newLayerIndexInList].index

                    const nextLayerIndex =
                      layerAbove?.index ??
                      getIndexAbove(highestShapeIndexOnCurrentLayer)

                    const index = getIndexBetween(
                      highestShapeIndexOnCurrentLayer,
                      nextLayerIndex,
                    )

                    return {
                      ...shape,
                      index,
                      props: { ...shape.props, layer: layerId },
                    }
                  }),
                )

                addToast({
                  title: "Changed Layer",
                  description: `Moved to ${layer.name}.`,
                })
              }}
            />
          )
        })}
      </TldrawUiMenuGroup>
      <TldrawUiMenuGroup id="new-layer">
        <TldrawUiMenuItem
          id={"new layer"}
          label={"New Layer"}
          onSelect={() => {
            editor.markHistoryStoppingPoint("move_shapes_to_layer")

            const newLayerId = `layer-${sortedLayers.length}`
            const newLayerName = `Layer ${sortedLayers.length}`

            editor.updatePage({
              ...page,
              meta: {
                ...page.meta,
                layers: {
                  ...page.meta.layers,
                  [newLayerId]: {
                    ...layers[page.meta.currentLayer],
                    id: newLayerId,
                    index: getIndexAbove(last(sortedLayers)!.index),

                    name: newLayerName,
                  },
                },
                currentLayer: newLayerId,
              },
            })
            editor.updateShapes(
              editor.getSelectedShapeIds().map((shapeId) => {
                const shape = editor.getShape(shapeId) as CustomDrawShape
                return {
                  ...shape,
                  props: { ...shape.props, layer: newLayerId },
                }
              }),
            )
            dispatch(setEditingLayer(true))

            addToast({
              title: "Moved to New Layer",
              description: `Moved to ${newLayerName}.`,
            })
          }}
        />
      </TldrawUiMenuGroup>
    </TldrawUiMenuSubmenu>
  )
}
